function SanitizeHtml({ filterText = "" }) {
  return <span dangerouslySetInnerHTML={{ __html: filterText}} />;
}

export default SanitizeHtml;
